import {Moment} from 'moment-timezone';
import HourlyForecastDate from './HourlyForecastDate';
import HourlyForecastItem from './HourlyForecastItem';

export default class Forecast {
  data: Record<string, unknown>[];
  timezone: string;
  dateList: HourlyForecastDate[];

  constructor(data: Record<string, unknown>[], timezone: string) {
    this.data = data;
    this.timezone = timezone;
    this.dateList = [];
    this.createHourlyForecast();
  }

  getHourlyForecastData() {
    return this.data;
  }

  getForecastDate(datetime: Moment) {
    for (const forecastDate of this.dateList) {
      if (forecastDate.getDate().isSame(datetime, 'day')) {
        return forecastDate;
      }
    }
    return null;
  }

  createHourlyForecast() {
    for (const item of this.getHourlyForecastData()) {
      // create a forecastItem
      const forecastItem = new HourlyForecastItem(this.timezone, item);
      // add it to the corresponding date container
      let correspondingDate = this.getForecastDate(forecastItem.getDatetime());
      if (correspondingDate !== null) {
        correspondingDate.addItem(forecastItem);
      } else {
        correspondingDate = new HourlyForecastDate(
          forecastItem.getDatetime(),
          this.timezone,
        );
        this.dateList.push(correspondingDate);
        correspondingDate.addItem(forecastItem);
      }
    }
  }

  getDateList() {
    return this.dateList;
  }
}
